// extracted by mini-css-extract-plugin
export var section = "data-capture-module--section--1_Pav";
export var main = "data-capture-module--main--3vE1V";
export var main_image = "data-capture-module--main_image--3p4Tf";
export var main_bar = "data-capture-module--main_bar--23fjK";